module.exports = __webpack_public_path__ + "static/hackers--painters-755a99325f7c8279bd4e1ac432d494e9.jpg";